import { render, staticRenderFns } from "./searchIndex.vue?vue&type=template&id=021cc72d&scoped=true&"
import script from "./searchIndex.vue?vue&type=script&lang=js&"
export * from "./searchIndex.vue?vue&type=script&lang=js&"
import style0 from "./searchIndex.vue?vue&type=style&index=0&id=021cc72d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cc72d",
  null
  
)

export default component.exports